
export default {
    name: "invitationCustomer",
    conditionData : "",
    data() {
        return {
            companyForm: {
                // 中文名称
                companyName: '',
                // 公司英文全称
                companyNameEn: '',
                wiffaMembertype: '',
                // 注册城市
                registryCity: '',
                // 公司注册地
                registerAddress: '',
                // 公司网站
                site: '',
                // 微信公众号
                wechatOfficalAccounts: '',
                // 公司电话
                companyTel: '',
                // 公司年营业额
                annualSalesVolume: '',
                // 年运输箱量
                annualTransportVolume: '',
                // 公司人数
                companyNos: '',
                // 公司成立日期
                companyTime: '',
                // 国际区号
                interNatCode: '',
                // 货代舱平台管理员姓名
                adminName: '',
                // 管理员手机
                adminMobile: '',
                // 管理员微信
                adminWeixin: '',
                // 服务特色
                serviceFeatures: '',
                // 业务需求
                businessRequire: '',
                // 公司法人姓名
                corporationName: '',
                // 总经理姓名
                generalManager: '',
                // 总经理电话
                generalManagerMobile: '',
                // 总经理邮箱
                generalManagerEmail: '',
                // 业务助理姓名
                assistantName: '',
                // 业务助理电话
                assistantMobile: '',
                // 业务助理邮箱
                assistantEmail: '',
                seals: [],
                socialCreditCode: null
            },
            isSendService : '',
            isCollectService : '',
            isPreview: false,
            previewTitle : this.$t('p_sealManage.seal_preview'),
            sealImage: ''
        }
    },
    mounted: function () {
    },
    created() {
        this.conditionData = this.$routerUtil.getParam();
        this.companyForm = Object.assign({}, this.companyForm, this.conditionData.row);
        if (this.companyForm.isSend !== 2) {
            this.isSendService = 'info';
        }
        if (this.companyForm.isReceive !== 2) {
            this.isCollectService = 'info';
        }
    },
    methods: {
        submitForm(formName) {
            console.log(this.$refs[formName], this.$refs);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const param = Object.assign({}, param, this.companyForm);
                    console.log(param);
                    this.$axios.post('/api/customerCompay/insertCustomerInvite', param).then(response => {
                        let type = 'error';
                        if (response.data.status === '1') {
                            type = 'success';
                            this.back();
                        }
                        this.$message({
                            // message: this.$t(response.data.message),
                            // 2021-01-29 修改提示消息 等待被邀请方和平台审核的提示
                            message: this.$t('companyManage.initiativeSuccess'),
                            type: type,
                            center: true
                        });
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    })
                }
            });
        },
        // 签章预览
        preview(item) {
            this.isPreview = true;
            this.sealImage = "/api" + item.dealFile;
        },
        back() {
            this.$routerUtil.setParam(this.conditionData.searchForm);
            this.$router.back();
        }
    }
}
